import { createSelector } from 'reselect';
var RevokeGiftOrderStoreSelector = function RevokeGiftOrderStoreSelector(store) {
  return store.customercare.recoverableUiState.revokeGiftOrder;
};
export var RevokeGiftOrderModelSelector = createSelector([RevokeGiftOrderStoreSelector], function (revokeGiftOrderStore) {
  return revokeGiftOrderStore.model;
});
export var IsRevokingGiftOrderSelector = createSelector([RevokeGiftOrderStoreSelector], function (revokeGiftOrderStore) {
  return revokeGiftOrderStore.isRevokingGiftOrder;
});
export var RevokeGiftOrderErrorMessagesSelector = createSelector([RevokeGiftOrderStoreSelector], function (revokeGiftOrderStore) {
  return revokeGiftOrderStore.revokeGiftOrderError && [revokeGiftOrderStore.revokeGiftOrderError.translatedMessage];
});